import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import axios from 'axios';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/OTPAuthentication2.css'; // Import the CSS file

class OTPAuthentication2 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      otp: '',
      message: '',
      errorMessage: '',
      isSubmitting: false
    };
  }

  // Handle OTP input change
  handleOTPChange = (e) => {
    this.setState({ otp: e.target.value });
  }

  // Submit OTP for verification
  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({ isSubmitting: true });

    try {
      // Send OTP to the backend
      const response = await axios.post('/otp2', { otp: this.state.otp });

      if (response.status === 200) {
        this.setState({ message: response.data.message, errorMessage: '', isSubmitting: false });

        // Optionally store the token in localStorage (you can remove this if not needed)
        localStorage.setItem('token', response.data.token);

        // Wait for 3 seconds before redirecting
        setTimeout(() => {
          // Redirect to ShowTokens route with the token
          this.props.history.push('/showtokens2', { token: response.data.token });
        }, 3000);
      } else {
        this.setState({ errorMessage: response.data.message, message: '', isSubmitting: false });
      }
    } catch (error) {
      if (error.response) {
        this.setState({ errorMessage: error.response.data.message, message: '', isSubmitting: false });
      } else {
        this.setState({ errorMessage: "An error occurred. Please try again later.", message: '', isSubmitting: false });
      }
    }
  }

  render() {
    return (
      <div className="token-container d-flex align-items-center justify-content-center">
        <div className="text-center">
          <img className='logo' src={logo} alt="Logo" />
          <br />
          <h2>OTP Authentication</h2>
          <div className="row justify-content-center">
            <div className="col-sm-8">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={this.handleSubmit}>
                    <div className="form-group">
                      <label htmlFor="otp">Enter OTP</label>
                      <input
                        type="text"
                        className="form-control"
                        name="otp"
                        id="otp"
                        value={this.state.otp}
                        onChange={this.handleOTPChange}
                        required
                      />
                    </div>
                    <button type="submit" className="btn btn-dark" disabled={this.state.isSubmitting}>
                      {this.state.isSubmitting ? 'Submitting...' : 'Submit OTP'}
                    </button>
                  </form>
                  {this.state.message && <div className="alert alert-success mt-3">{this.state.message}</div>}
                  {this.state.errorMessage && <div className="alert alert-danger mt-3">{this.state.errorMessage}</div>}
                  <div className="text-center mt-3">
                    <div>Powered by</div>
                
                    <img className='logo2' src={logo2} alt="Logo 2" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(OTPAuthentication2);
